import { HTMLAttributes } from 'react';
import { cn } from 'utils/styles';
interface CardGridProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export function CardGrid({ children, className, ...props }: CardGridProps) {
  return (
    <div className={cn('grid grid-flow-col gap-x-2.5 sm:gap-x-6', className)} {...props}>
      {children}
    </div>
  );
}
